import './branch-active-deliveries/branch-active-deliveries.component';
import './branch-active-deliveries/branch-active-deliveries.scss';

import './branch-delivery-history/branch-delivery-history.component';
import './branch-delivery-history/branch-delivery-history.scss';

import './branch-details/branch-details.component';
import './branch-details/branch-details.scss';

import './branch-display-value/branch-display-value.component';
import './branch-display-value/branch-display-value.scss';

import './branch-schedule-view/branch-schedule-view.component'
import './branch-schedule-view/branch-schedule-view.scss'

import './branch-select/branch-select.component';
import './branch-select/branch-select.scss';

import './branch-select-list/branch-select-list.component';
import './branch-select-list/branch-select-list.scss';

import './branches-multi-select/branches-multi-select.component';
import './branches-multi-select/branches-multi-select.scss';

import './branch-service-areas/branch-service-areas.component';

import './branches-agents-view/branches-agents-view.component';
import './branches-agents-view/branches-agents-view.scss';

import './branches-depots-view/branches-depots-view.component';
import './branches-depots-view/branches-depots-view.scss';

import './branches-display-list/branches-display-list.component';
import './branches-display-list/branches-display-list.scss';

import './branches-indicator/branches-indicator.component';
import './branches-indicator/branches-indicator.scss';

import './branches-info-view/branches-info-view.component';
import './branches-info-view/branches-info-view.scss';

import './branches-multi-select-list/branches-multi-select-list.component';
import './branches-multi-select-list/branches-multi-select-list.scss';

import './branches-shipper-accounts-view/branches-shipper-accounts-view.component';
import './branches-shipper-accounts-view/branches-shipper-accounts-view.scss';

import './branches-table/branches-table.component';
import './branches-table/branches-table.scss';

import './branches-table-row/branches-table-row.component';
import './branches-table-row/branches-table-row.scss';

import './branches-view/branches-view.component';
import './branches-view/branches-view.scss';
